<svg width="22" height="19" viewBox="0 0 22 19" xmlns="http://www.w3.org/2000/svg"><path d="M11 0L0 19H22L11 0ZM11 4L14.765 10.5L18.53 17H3.47L11 4ZM10 8V12H12V8H10ZM10 14V16H12V14" fill="#FFFFFF"/></svg>
